export default "__VITE_ASSET__BUjcHShx__"